<div
  class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm p-4"
>
  <!-- Contenedor blanco del modal -->

  <div
    class="p-6 relative flex w-full max-h-[90%] max-w-xl flex-col overflow-auto rounded-2xl bg-white shadow-xl gap-y-6"
  >
    <div
      (click)="closeModal()"
      class="absolute right-4 top-4 p-2 items-center flex rounded-full text-black hover:bg-gray-300"
    >
      <mat-icon fontIcon="close"></mat-icon>
    </div>

    <div class="p-4 w-full space-y-4">
      <h2 class="title-modal">Notificaciones</h2>

      @if (notifications.length > 0) { @for (notif of notifications; track
      $index) {
      <div
        class="flex justify-between items-start gap-4 p-4 bg-white border-b hover:bg-gray-50 transition cursor-pointer"
        [class.opacity-50]="notif.read"
      >
        <!-- Contenido principal -->
        <div class="flex-1" (click)="handleAction(notif)">
          <p class="text-sm text-gray-800">
            <span class="font-semibold">{{ notif.title }}</span>
            {{ notif.description }}
          </p>
        </div>

        <!-- Hora y estado -->
        <div class="text-right whitespace-nowrap flex flex-col items-end gap-1">
          <span class="text-xs text-gray-500">{{
            notif.date | date : "short"
          }}</span>
        </div>

        <div
          class="text-right whitespace-nowrap flex flex-col items-center gap-1"
        >
          <button
            class="text-gray-400 hover:text-red-500 transition"
            (click)="deleteNotification(notif)"
            title="Eliminar notificación"
          >
            <mat-icon fontIcon="delete_outline" class="text-base"></mat-icon>
          </button>
          @if (!notif.read) {
          <span class="w-2 h-2 bg-black rounded-full"></span>
          }
        </div>
        <!-- Botón eliminar -->
      </div>
      } } @else {
      <div class="p-4 bg-white text-gray-500">
        No tienes notificaciones nuevas.
      </div>
      } @if (!loadingMore && notifications.length < totalNotifications) {
      <div class="text-center mt-4">
        <a (click)="loadNotifications()" class="action"> Ver más </a>
      </div>
      } @if (loadingMore) {
      <div class="text-center text-sm text-gray-500 py-2">
        Cargando más notificaciones...
      </div>
      }

      <div class="text-right pt-4">
        <button class="cancel" (click)="closeModal()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
